<template lang="pug">
el-tooltip(
        v-if='usuarioIsLaudo && atalho.nome !== "Solicitar Laudo"'
        effect='dark',
        placement='top-start',
        :content='$t("mensagens.home.usuarioLaudos.naoPossuiAcessoModulo")'
    )
    .atalho(@click='irParaRota', :style='{ cursor: usuarioIsLaudo && atalho.nome !== "Solicitar Laudo" ? "not-allowed" : "pointer", opacity: usuarioIsLaudo && atalho.nome !== "Solicitar Laudo" ? 0.5 : 1}')
        section.atalho__imagem
            img(:src='atalho.linkIcone', alt='atalho', height='100%', width='100%')
        section.atalho__titulo
            | {{ internacionalizarNomes(atalho.nome) }}
.atalho(v-else, @click='irParaRota')
        section.atalho__imagem
            img(:src='atalho.linkIcone', alt='atalho', height='100%', width='100%')
        section.atalho__titulo
            | {{ internacionalizarNomes(atalho.nome) }}
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'Atalho',
    props: {
        atalho: {
            type: Object,
            required: true,
            default: () => {}
        },
        habilitarAcaoRota: {
            type: Boolean,
            required: false,
            default: true
        }
    },
    computed: {
        ...mapState(['usuarioIsLaudo'])
    },
    methods: {
        internacionalizarNomes(nome) {
            let nomeFormatado = nome
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .replace(/[^a-zA-Z0-9 ]/g, '')
                .replace(/\s+/g, '-')
                .toUpperCase();
            return this.$t(
                `mensagens.home.acessoRapido.botoes.${nomeFormatado}`
            );
        },
        irParaRota() {
            if (this.usuarioIsLaudo && this.atalho.nome !== 'Solicitar Laudo') return;
            if (this.habilitarAcaoRota) {
                this.$router.push(this.atalho.nomeRota);
            }
        }
    }
};
</script>

<style scoped lang="scss">
.atalho {
    width: 100px;
    min-width: 100px;
    height: 90px;
    padding: 10px 5px;
    background: var(--white);
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    cursor: pointer;

    .atalho__imagem {
        height: 30px;
        width: 100%;
    }

    .atalho__titulo {
        margin-top: 6px;
        width: 100%;
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        height: auto;
        line-height: 1.3em;
        text-align: center;
        overflow: hidden;
        color: var(--primary);
        letter-spacing: -0.5px;
    }
}
</style>
